/* RESPONSIBLE TEAM: team-data-foundations */

export const AVAILABLE_ACTION_COLUMNS = [
  {
    valuePath: 'name',
    isSortable: true,
    minWidth: '350px',
  },
  {
    valuePath: 'usage',
    isSortable: true,
    hasTooltip: true,
  },
  {
    valuePath: 'sentCount',
    isSortable: true,
    type: 'number',
    hasTooltip: true,
  },
  {
    valuePath: 'resolvedCount',
    isSortable: true,
    type: 'number',
    hasTooltip: true,
  },
  {
    valuePath: 'customerVerification',
    type: 'stamp',
    hasTooltip: true,
  },
  {
    valuePath: 'state',
    isSortable: true,
    type: 'stamp',
  },
  {
    valuePath: 'health',
    type: 'stamp',
    hasTooltip: true,
  },
  {
    valuePath: 'successRate',
    isSortable: true,
    hasTooltip: true,
  },
  {
    valuePath: 'createdBy',
    type: 'avatar-with-text',
  },
  {
    valuePath: 'updatedBy',
    type: 'avatar-with-text',
  },
  {
    valuePath: 'updatedAt',
    isSortable: true,
  },
  {
    valuePath: 'audienceMode',
    isSortable: true,
  },
  {
    valuePath: 'dependentObjects',
    isSortable: true,
    hasTooltip: true,
  },
];

export const AVAILABLE_ACTION_COLUMNS_FOR_MCP_ACTIONS = [
  {
    valuePath: 'deleteAction',
  },
];

export const DEFAULT_ACTION_COLUMN_NAMES = [
  'usage',
  'sentCount',
  'resolvedCount',
  'state',
  'dependentObjects',
];

export const DEFAULT_ACTION_COLUMNS = AVAILABLE_ACTION_COLUMNS.filter(
  (column) => DEFAULT_ACTION_COLUMN_NAMES.includes(column.valuePath) || column.valuePath === 'name',
);
